/*
 * Revenue Report Page - FINAL DESIGN VERSION
 * UI exactly based on the shared screenshot
 */

import { Fragment, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { CustomLoader, EmptyScreen, RevenueFilter } from "../../../Components/Other";
import { CustomDateRangePicker, DataTableContainer, CustomSearchSelectBox, SearchInput } from "../../../Components/FormElements";
import { DownloadButton, GradientButton } from "../../../Components/Cta";
import { Icon } from "../../../Components/Icon";
import { NavigationHeader } from "../../../Components/Header";
import Colors from "../../../Styles/color.module.scss";
import { toast } from "react-toastify";
import APIService from "../../../Services/api-service";


// ---------------- MAIN PAGE ----------------


const DEFAULT_ZONE_NAME = "CHANDIGARH";

const TABLE_STYLE = {
    table: {
        style: {
            padding: "12px 16px 16px 0px",
            background: Colors.white,
        },
    },
    tableBody: {
        style: {
            margin: '0px',
            marginTop: "0px !important"
        }
    },
    headRow: {
        style: {
            background: 'transparent',
            borderRadius: "16px 16px 0px 0px",
            border: "0",
            borderBottom: `1px solid ${Colors.bright_gray} !important`,
            fontSize: "14px",
            fontFamily: "Poppins-Medium",
            lineHeight: "24px",
            color: Colors.black
        }
    },
    rows: {
        style: {
            margin: "0",
            background: "transparent",
            border: `1px solid ${Colors.bright_gray} !important`,
            borderRadius: "16px",
            marginTop: "14px",
            fontSize: "16px",
            fontFamily: "Poppins-Regular",
            lineHeight: "24px",
            cursor: "pointer",
            color: Colors.black,
            '&:hover': {
                boxShadow: '0px 12px 16px 0px rgba(50, 50, 71, 0.08)',
            },
        },
    },
    cells: {
        style: {
            '&:not(:last-child)': {
                paddingLeft: '0px',
                paddingRight: '0px',
                display: 'flex',
            },
            '&:first-child': {
                padding: "24px 0px 24px 24px",
            }
        },
    },
    headCells: {
        style: {
            '&:not(:last-child)': {
                paddingLeft: '0px',
                paddingRight: '0px',
                display: 'flex',
            },
            '&:first-child': {
                padding: "24px 0px 24px 20px",
            },
        },
    },
    pagination: {
        style: {
            borderTop: `none `,
            color: Colors.outer_space,
            fontSize: '16px',
            fontFamily: "Poppins-Regular",
        },
    }
}




// function getMonthYearOptions(startYear = 2015) {
//     const now = new Date();
//     const currentYear = now.getFullYear();
//     const currentMonth = now.getMonth() + 1; // 1 = January

//     const months = [
//         { value: 1, label: "January" },
//         { value: 2, label: "February" },
//         { value: 3, label: "March" },
//         { value: 4, label: "April" },
//         { value: 5, label: "May" },
//         { value: 6, label: "June" },
//         { value: 7, label: "July" },
//         { value: 8, label: "August" },
//         { value: 9, label: "September" },
//         { value: 10, label: "October" },
//         { value: 11, label: "November" },
//         { value: 12, label: "December" }
//     ];

//     const options = [];

//     for (let year = currentYear; year >= startYear; year--) {
//         const maxMonth = year === currentYear ? currentMonth : 12;

//         for (let m = 1; m <= maxMonth; m++) {
//             const month = months[m - 1];
//             options.push({
//                 value: `${year}-${m.toString().padStart(2, "0")}`,
//                 label: `${month.label} ${year}`
//             });
//         }
//     }

//     return options;
// }


function getMonthYearOptions() {
    const now = new Date();

    const months = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];

    const options = [];

    // Last 3 months available for reporting: brokerage for a month is received after the following month
    // (e.g. March data after April), so the newest month in the list is two calendar months before today.
    const newestSelectable = new Date(now.getFullYear(), now.getMonth() - 1, 1);

    for (let i = 0; i < 3; i++) {
        const date = new Date(newestSelectable.getFullYear(), newestSelectable.getMonth() - i, 1);

        const year = date.getFullYear();
        const monthIndex = date.getMonth(); // 0–11
        const monthNumber = (monthIndex + 1).toString().padStart(2, "0");

        options.push({
            value: `${year}-${monthNumber}`,
            label: `${months[monthIndex]} ${year}`
        });
    }

    return options;
}



const RevenueReport = () => {

    // const popupRef = useRef(null);
    const ADMIN_PROFILE = useSelector(state => state.MT_ADMIN_STORE.ADMIN_PROFILE);
    const adminTypeId = ADMIN_PROFILE?.admin_type_id;

    // Filter visibility by admin type: 1-3 = all; 4 = hide zone; 5 = hide zone+region; 6 = hide zone+region+branch; 7 = RM (hide zone,region,branch,RM); 8 = AP (hide all above + AP)
    const showZoneFilter = adminTypeId >= 1 && adminTypeId <= 3;
    const showRegionFilter = adminTypeId >= 1 && adminTypeId <= 4;
    const showBranchFilter = adminTypeId >= 1 && adminTypeId <= 5;
    const showRMFilter = adminTypeId >= 1 && adminTypeId <= 6;
    const showAPFilter = adminTypeId >= 1 && adminTypeId <= 7;

    const [loader, setLoader] = useState(true);
    const [zoneFilter, setZoneFilter] = useState([]);

    console.log('zoneFilter', zoneFilter);
    console.log('adminTypeId', adminTypeId);


    const [regionFilter, setRegionFilter] = useState([]);
    const [branchFilter, setBranchFilter] = useState([]);
    const [rmFilter, setRmFilter] = useState([]);
    const [apFilter, setApFilter] = useState([]);

    const [searchQuery, setSearchQuery] = useState("");
    const [showFilterPanel, setShowFilterPanel] = useState(false);
    const [revenueList, setRevenueList] = useState([]);
    console.log('revenueList', revenueList);
    const [revenueCardDetails, setRevenueCardDetails] = useState({});
    const [adminType, setAdminType] = useState([]);
    const [appliedFilters, setAppliedFilters] = useState({});


    // Individual states
    const [month, setMonth] = useState(null);
    console.log('expected_month', month);

    const [zoneValue, setZoneValue] = useState(null);
    const [regionValue, setRegionValue] = useState(null);
    const [branchValue, setBranchValue] = useState(null);
    const [rmValue, setRmValue] = useState(null);
    const [apValue, setApValue] = useState(null);
    const [adminValue, setAdminValue] = useState(null);
    const [assetValue, setAssetValue] = useState(null);
    console.log('assetValue', assetValue);

    const [trxnValue, setTrxnValue] = useState(null);
    const [subTrxnValue, setSubTrxnValue] = useState(null);
    const [monthOptions, setMonthOptions] = useState([]);
    console.log('monthOptions', monthOptions);


    const [assetTypeFilter, setAssetTypeFilter] = useState([]);
    console.log('assetTypeFilter', assetTypeFilter);

    const [transactionTypeFilter, setTransactionTypeFilter] = useState([]);
    const [subTransactionTypeFilter, setSubTransactionTypeFilter] = useState([]);

    const [selectAll, setSelectAll] = useState(false);
    const [selectedRows, setSelectedRows] = useState(new Set());
    const [rowSelectFalse, setRowSelectFalse] = useState(false);

    // Server-side pagination (page_size 10 by default)
    const [pageNum, setPageNum] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [totalRows, setTotalRows] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [paginationData, setPaginationData] = useState(null);
    const [downloadLoader, setDownloadLoader] = useState(false);

    // parent (RevenueReport) top-level states
    const [monthMenuOpen, setMonthMenuOpen] = useState(false);
    const [tempMonth, setTempMonth] = useState(null); // temp selection inside popover



    const getAppliedFilterCount = () => {
        let count = 0;

        if (appliedFilters.month) count++;
        if (showZoneFilter && appliedFilters.zone) count++;
        if (showRegionFilter && appliedFilters.region) count++;
        if (showBranchFilter && appliedFilters.branch) count++;
        if (showRMFilter && appliedFilters.rm) count++;
        if (showAPFilter && appliedFilters.ap) count++;
        if (appliedFilters.admin) count++;
        if (appliedFilters.asset) count++;
        if (appliedFilters.transaction) count++;
        if (appliedFilters.trunction) count++;

        return count;
    };

    const activeFilterCount = getAppliedFilterCount();

    console.log('activeFilterCount', activeFilterCount);



    useEffect(() => {
        setMonthOptions(getMonthYearOptions());
    }, []);

    // Initial load + refetch when search is cleared. When zone filter is shown, only the first-zone effect calls the API (with default zone).
    useEffect(() => {
        if (searchQuery.length !== 0) return;
        if (showZoneFilter) return; // first-zone effect will call _revenueReport with default zone
        _revenueReport(appliedFilters, searchQuery);
    }, [searchQuery, showZoneFilter]);

    useEffect(() => {
        // __getAdminTypes();
        __getGeneralFilters();
    }, []);

    // Call zone/region/branch APIs only when filters are allowed for this admin type
    useEffect(() => {
        if (showZoneFilter) {
            _zoneFilter();
        }
    }, [showZoneFilter]);

    // When zones are loaded, select default zone (CHANDIGARH) and pass to revenue report
    useEffect(() => {
        if (!showZoneFilter || zoneFilter.length === 0 || zoneValue !== null) return;
        const defaultZone = zoneFilter.find(z => z.label === DEFAULT_ZONE_NAME) ?? zoneFilter[0];
        setZoneValue(defaultZone);
        setAppliedFilters(prev => ({ ...prev, zone: defaultZone }));
        if (showRegionFilter) _regionFilter(defaultZone.value);
        _revenueReport({ zone: defaultZone }, searchQuery, 1, pageSize);
    }, [zoneFilter, showZoneFilter, zoneValue]);

    useEffect(() => {
        if (rowSelectFalse === true) {
            setSelectAll(false);
        }
    }, [rowSelectFalse]);

    useEffect(() => {
        if (selectAll === true) {
            const allIds = new Set(revenueList.map(item => item.id));
            setSelectedRows(allIds);
            setRowSelectFalse(false);
        } else {
            if (rowSelectFalse === false) {
                setSelectedRows(new Set());
            }
        }
    }, [selectAll, revenueList]);



    const REVENUE_COLUMNS = [
        {
            name: (
                <div className={`position-relative w-fit-content padding-40px-left`}>
                    <Icon
                        icon={selectAll ? "checked" : "unchecked"}
                        size={22}
                        className="position-absolute left-10 cursor-pointer"
                        onClick={(event) => _handleSelectAll(event)}
                    />
                    <p className="mb-0">Sl.No</p>
                </div>
            ),
            selector: row => row.id,
            sortable: true,
            width: "170px",
            cell: row => (
                <div className="d-flex align-items-center gap-12px ps-2">
                    <Icon
                        icon={selectedRows.has(row.id) ? "checked" : "unchecked"}
                        size={22}
                        onClick={(event) => _handleRowCheckBox(row, event)}
                    />
                    <p className="mb-0">{row.id}</p>
                </div>
            )
        },
        // { name: "Client ID", selector: r => r.id, width: "140px" },
        { name: "Client name", selector: r => r.client_name, width: "220px" },
        { name: "PAN number", selector: r => r.pan_number || '-', width: "180px" },
        { name: "Scheme name", selector: r => r.scheme_name, width: "480px" },
        { name: "Branch code", selector: r => r.branch_code, width: "160px" },
        { name: "Zone name", selector: r => r.zone_name || '-', width: "150px" },
        { name: "Region name", selector: r => r.region_name || '-', width: "240px" },
        { name: "Employee name", selector: r => r.client_name, width: "220px" },
        { name: "Employee code", selector: r => r.employee_code, width: "160px" },
        { name: "Agent name", selector: r => r.agent_name, width: "220px" },
        { name: "Agent code", selector: r => r.agent_code, width: "150px" },
        { name: "Folio No", selector: r => r.folio_no, width: "180px" },
        { name: "Tran date", selector: r => r.trxn_date, width: "220px" },
        { name: "Amount", selector: r => r.amount, width: "150px" },
        { name: "Asset type", selector: r => r.asset_type, width: "150px" },
        { name: "Trxn type", selector: r => r.trxn_type, width: "150px" },
        { name: "Sub trxn type", selector: r => r.sub_trxn_type || '-', width: "150px" },
        { name: "Sub broker revenue", selector: r => r.sub_broker_revenue, width: "180px" },
        { name: "Employee revenue", selector: r => r.employee_revenue, width: "160px" },
        { name: "Period from", selector: r => r.period_from, width: "130px" },
        { name: "Period to", selector: r => r.period_to, width: "150px" },
    ];

    const revenueCards = [
        { key: "total_revenue", label: "Total revenue" },
        { key: "ap_revenue", label: "AP revenue" },
        { key: "dir_revenue", label: "DIR revenue" }
    ];

    const _handleSearchQuery = (value) => {
        setSearchQuery(value);
    }

    const _handlePress = (value) => {
        _revenueReport(appliedFilters, value);
    };


    const _handleSelectAll = (event) => {
        event.stopPropagation();
        setSelectAll(!selectAll);
    };

    const _handleRowCheckBox = (row, event) => {
        event.stopPropagation();

        if (selectedRows.has(row.id)) {
            setSelectedRows(prev => {
                const updated = new Set(prev);
                updated.delete(row.id);
                return updated;
            });
        } else {
            setSelectedRows(prev => new Set([...prev, row.id]));
        }
        setRowSelectFalse(true);
    };

    const _revenueReport = (filters = {}, query = searchQuery, page = pageNum, size = pageSize) => {
        setLoader(true);
        const url = "reports/revenue-report";

        const payload = {
            query: query,
            month: filters.month?.value ?? "",
            zone: filters.zone?.code ?? "",
            region: filters.region?.code ?? "",
            branch: filters.branch?.code ?? "",
            rmcode: filters.rm?.code ?? "",
            ap: filters.ap?.code ?? "",
            asset_type: filters.asset?.value ?? "",
            trxn_type: filters.transaction?.value ?? "",
            sub_trxn_type: filters.trunction?.value ?? "",
            page_num: page,
            page_size: size,
        };

        APIService(true, url, payload).then((response) => {
            if (response.status_code === 200) {
                setRevenueCardDetails(response.totals ?? {});
                setRevenueList(response.data ?? []);
                const count = response.count ?? response.total ?? response.total_count ?? response.total_rows ?? (response.data?.length ?? 0);
                const totalPagesVal = response.total_pages ?? (count > 0 ? Math.ceil(count / size) : 0);
                setTotalRows(count);
                setTotalPages(totalPagesVal);
                setPaginationData({
                    rowsPerPageText: `${page} of ${totalPagesVal} | Total records: ${count}`,
                });
            } else {
                toast.dismiss();
                toast.error(response.message);
            }
            setLoader(false);
        });
    };


    const _zoneFilter = () => {
        let is_post = false;
        let url = 'client_mapping/zone/list';
        APIService(is_post, url).then((response) => {
            if (response.status_code === 200) {
                const mapped = response.data.map(zone => ({
                    // ...zone,
                    label: zone.name,
                    value: zone.id,
                    code: zone.code  // FIXED
                }));
                setZoneFilter(mapped);
            } else {
                toast.dismiss();
                toast.error(response.message);
            }
        })
    };

    const _regionFilter = (zone_id) => {
        let is_post = true;
        let url = 'client_mapping/region/list';
        let payload = {
            id: zone_id
        }
        APIService(is_post, url, payload).then((response) => {
            if (response.status_code === 200) {
                const mapped = response.data.map((region) => ({
                    // ...region,
                    label: region.code,
                    value: region.id,
                    code: region.code
                }));
                setRegionFilter(mapped);
            } else {
                // toast.dismiss();
                // toast.error(response.message);
            }
        })
    };

    const _branchFilter = (region_id) => {
        let is_post = true;
        let url = 'client_mapping/branch/list';
        let payload = {
            "id": region_id
        }
        APIService(is_post, url, payload).then((response) => {
            if (response.status_code === 200) {
                const mapped = response.data.map((branch) => ({
                    label: branch.code,
                    value: branch.id,
                    code: branch.code
                }));
                setBranchFilter(mapped);
            } else {
                toast.dismiss();
                toast.error(response.message);
            }
        })
    };

    const _rmFilter = (branch_id) => {
        if (!showRMFilter) return;
        let is_post = true;
        let url = 'client_mapping/rm/list';
        let payload = { id: branch_id };
        APIService(is_post, url, payload).then((response) => {
            if (response.status_code === 200) {
                const mapped = (response.data || []).map((rm) => ({
                    label: rm.code,
                    value: rm.id,
                    code: rm.code
                }));
                setRmFilter(mapped);
            } else {
                toast.dismiss();
                toast.error(response.message);
            }
        });
    };

    const _apFilter = (rm_id) => {
        if (!showAPFilter) return;
        let is_post = true;
        let url = 'client_mapping/ap/list';
        let payload = { id: rm_id };
        APIService(is_post, url, payload).then((response) => {
            if (response.status_code === 200) {
                const mapped = (response.data || []).map((ap) => ({
                    label: ap.code,
                    value: ap.id,
                    code: ap.code
                }));
                setApFilter(mapped);
            } else {
                toast.dismiss();
                toast.error(response.message);
            }
        });
    };


    // API - list admin types
    // function _getAdminTypes() {
    //     return new Promise((resolve, reject) => {
    //         let url = 'auth/list-admin-types';

    //         APIService(false, url).then((response) => {
    //             if (response.status_code === 200) {
    //                 resolve(response.data);
    //             } else {
    //                 reject(response.message);
    //             }
    //         }).catch((error) => {
    //             reject(error);
    //         });
    //     });
    // };


    const __getGeneralFilters = () => {
        APIService(false, 'client_mapping/general-filters')
            .then((response) => {

                if (response.status_code === 200) {

                    console.log("response", response.data);

                    const data = response.data[0] || {};  // extract first object safely

                    // Previous dynamic options (kept for reference):
                    // const assetTypes = (data.asset_types || []).map(item => ({
                    //     label: item.name,
                    //     value: item.id
                    // }));
                    //
                    // const transactionTypes = (data.transaction_types || []).map(item => ({
                    //     label: item.name,
                    //     value: item.id
                    // }));

                    // Use ONLY these static options for asset type
                    // and transaction type (values passed as strings)
                    const assetTypes = [
                        { label: "Equity", value: "Equity" },
                        { label: "Debt", value: "Debt" },
                        { label: "Others", value: "Others" },
                    ];

                    const transactionTypes = [
                        { label: "Purchase", value: "Purchase" },
                        { label: "Redemption", value: "Redemption" },
                    ];

                    const subTransactionTypes = (data.sub_truncation || []).map(item => ({
                        label: item.name,
                        value: item.id
                    }));

                    // Set states
                    setAssetTypeFilter(assetTypes);
                    setTransactionTypeFilter(transactionTypes);
                    setSubTransactionTypeFilter(subTransactionTypes);

                } else {
                    toast.dismiss();
                    toast.error(response.message);
                }

            })
            .catch(() => {
                toast.dismiss();
                toast.error("Failed to load general filters");
            });
    };



    const _reportDownload = () => {
        setDownloadLoader(true);
        let is_post = true;
        let url = "reports/revenue-report-download";

        const payload = {
            query: searchQuery,
            month: month?.value ?? "",
            zone: zoneValue?.code ?? "",
            region: regionValue?.code ?? "",
            branch: branchValue?.code ?? "",
            rmcode: rmValue?.code ?? "",
            ap: apValue?.code ?? "",
            asset_type: assetValue?.value ?? "",
            trxn_type: trxnValue?.value ?? "",
            sub_trxn_type: subTrxnValue?.value ?? "",
        };

        APIService(is_post, url, payload).then((response) => {
            if (response.status_code === 200) {
                window.open(response.url.file_url, "_blank");
            } else {
                toast.dismiss();
                toast.error(response.message);
            }
        }).finally(() => {
            setDownloadLoader(false);
        });
    };


    // ---------------- FILTER PANEL ----------------
    const RevenueFilterPanel = ({
        month, setMonth,
        zone, setZone,
        region, setRegion,
        branch, setBranch,
        rm, setRm,
        ap, setAp,
        admin, setAdmin,
        asset, setAsset,
        transaction, setTransaction,
        trunction, setTrunction,

        zoneFilter, regionFilter, branchFilter, rmFilter, apFilter, adminType,
        setRmFilter, setApFilter,
        assetTypeFilter, transactionTypeFilter, subTransactionTypeFilter,
        _regionFilter, _branchFilter, _rmFilter, _apFilter,
        showZoneFilter, showRegionFilter, showBranchFilter, showRMFilter, showAPFilter,
        onApplyFilter, onClear
    }) => {


        const handleZoneChange = (value) => {

            setZone(value);

            // Reset dependent filters immediately
            setRegion(null);
            setRegionFilter([]);   // FIX
            setBranch(null);
            setBranchFilter([]);
            setRm(null);
            setRmFilter([]);
            setAp(null);
            setApFilter([]);

            if (showRegionFilter && value) {
                _regionFilter(value.value);
            }

        };

        const handleRegionChange = (value) => {
            setRegion(value);
            setBranch(null);
            if (showBranchFilter) {
                _branchFilter(value.value);
            } else {
                setBranchFilter([]);
            }
            setRm(null);
            setRmFilter([]);
            setAp(null);
            setApFilter([]);
        };

        const handleBranchChange = (value) => {
            setBranch(value);
            if (showRMFilter && value) {
                _rmFilter(value.value);
            } else {
                setRmFilter([]);
            }
            setRm(null);
            setAp(null);
            setApFilter([]);
        };

        const handleRMChange = (value) => {
            setRm(value);
            if (showAPFilter && value) {
                _apFilter(value.value);
            } else {
                setApFilter([]);
            }
            setAp(null);
        };



        const handleClear = () => {
            onClear();
            setShowFilterPanel(false);
        };

        const handleApply = () => {
            onApplyFilter({ month, zone, region, branch, rm, ap, admin, asset, transaction, trunction });
        };

        const openMonthMenu = () => {
            setTempMonth(month); // initialise from current selection
            setMonthMenuOpen(true);
        };

        const closeMonthMenu = () => {
            setMonthMenuOpen(false);
        };

        const handleMonthRadioChange = (option) => {
            setTempMonth(option);
        };

        const applyMonthSelection = () => {
            setMonth(tempMonth);
            setMonthMenuOpen(false);
        };


        return (
            <div className="bg-white border-radius-16px p-3 mb-4 e-filter-revenue" style={{ border: "1px solid #E0E0E0" }}>
                <p className="e-poppins-medium e-font-14 color-light-black line-height-18px mb-2">Filters</p>

                <div className="row g-3">
                    <div className="col-lg-3 col-sm-6 position-relative">
                        {/* Control that looks like a select (bootstrap utility classes) */}
                        <div
                            className="month-select-control position-relative custom-select-box cursor-pointer"
                            onClick={(e) => { e.stopPropagation(); openMonthMenu(); }}
                        >



                            <div className={`d-flex align-items-center justify-content-between `}>


                                {
                                    <span
                                        className={`color-outer-space e-poppins-regular e-report-filter-label  e-font-14 line-height-24px 
                                           bg-white `}
                                        data-valid={month?.value ? 'true' : 'false'}
                                    >
                                        Month
                                    </span>

                                }


                                <span className="e-poppins-medium color-charleston-green">
                                    {month?.label ? month?.label : ''}
                                </span>


                                <span className="arrow-icon-report">
                                    <Icon icon="right-arrow"
                                        width="20px"
                                        height="20px"
                                        className={monthMenuOpen ? 'dropdown-icon ' : `rotate-90deg`}
                                        color={Colors.space_cadet} />
                                </span>
                            </div>
                        </div>


                        {/* Backdrop + Popover (rendered when open) */}
                        {monthMenuOpen && (
                            <>
                                {/* backdrop */}
                                <div className="month-backdrop"
                                    onClick={closeMonthMenu} />

                                {/* popover card */}
                                <div className="month-popover card">
                                    <div className="card-body p-2 border-0">
                                        <h6 className="mb-0 e-poppins-medium e-font-14 line-height-18px color-black">Select month</h6>
                                    </div>

                                    <div className="month-list list-group list-group-flush">
                                        {monthOptions.map((opt) => (
                                            <label
                                                key={opt.value}
                                                className=" list-group-item-action d-flex align-items-center  month-option"
                                                onClick={() => handleMonthRadioChange(opt)}
                                            >
                                                {/* <input
                                                    type="radio"
                                                    name="month-radio"
                                                    checked={tempMonth?.value === opt.value}
                                                    readOnly
                                                    className="form-check-input "
                                                /> */}
                                                <Icon
                                                    size={20}
                                                    icon={tempMonth?.value === opt.value ? `radio-selected` : 'radio-unselected'}
                                                />
                                                <span className={tempMonth?.value === opt.value ? "e-poppins-medium" : "e-poppins-regular e-font-14 line-height-22px color-black"}>
                                                    {opt.label}
                                                </span>
                                            </label>
                                        ))}
                                    </div>

                                    <div className="card-footer bg-white d-flex justify-content-end gap-2">

                                        <GradientButton label={"Apply"}
                                            disabled={!tempMonth}
                                            onPress={applyMonthSelection}
                                            className="me-2 border-radius-8px e-font-14 line-height-14px e-poppins-regular py-2 " />
                                    </div>
                                </div>
                            </>
                        )}
                    </div>

                    {/* <div className="col-lg-3 col-sm-6">
                        <CustomSearchSelectBox
                            label="Admin type"
                            options={adminType}
                            value={admin}
                            onSelectChange={setAdmin}
                        />
                    </div> */}

                    {showZoneFilter && (
                        <div className="col-lg-3 col-sm-6">
                            <CustomSearchSelectBox
                                label="Region"
                                options={zoneFilter}
                                value={zone}
                                onSelectChange={handleZoneChange}
                            />
                        </div>
                    )}

                    {showRegionFilter && (
                        <div className="col-lg-3 col-sm-6">
                            <CustomSearchSelectBox
                                label="Zone"
                                options={regionFilter}
                                value={region}
                                isDisabled={!zone}
                                onSelectChange={handleRegionChange}
                            />
                        </div>
                    )}

                    {showBranchFilter && (
                        <div className="col-lg-3 col-sm-6">
                            <CustomSearchSelectBox
                                label="Branch"
                                options={branchFilter}
                                value={branch}
                                isDisabled={!region}
                                onSelectChange={handleBranchChange}
                            />
                        </div>
                    )}

                    {showRMFilter && (
                        <div className="col-lg-3 col-sm-6">
                            <CustomSearchSelectBox
                                label="RM"
                                options={rmFilter}
                                value={rm}
                                isDisabled={!branch}
                                onSelectChange={handleRMChange}
                            />
                        </div>
                    )}

                    {showAPFilter && (
                        <div className="col-lg-3 col-sm-6">
                            <CustomSearchSelectBox
                                label="AP"
                                options={apFilter}
                                value={ap}
                                isDisabled={!rm}
                                onSelectChange={setAp}
                            />
                        </div>
                    )}

                    <div className="col-lg-3 col-sm-6">
                        <CustomSearchSelectBox
                            label="Asset type"
                            options={assetTypeFilter}
                            value={asset}
                            onSelectChange={setAsset}
                        />
                    </div>

                    <div className="col-lg-3 col-sm-6">
                        <CustomSearchSelectBox
                            label="Transaction type"
                            options={transactionTypeFilter}
                            value={transaction}
                            onSelectChange={setTransaction}
                        />
                    </div>

                    <div className="col-lg-3 col-sm-6">
                        <CustomSearchSelectBox
                            label="Sub transaction"
                            options={subTransactionTypeFilter}
                            value={trunction}
                            onSelectChange={setTrunction}
                        />
                    </div>
                </div>

                <div className="d-flex justify-content-end gap-3 mt-4">
                    <button className="border-radius-8px  e-poppins-regular e-font-14 line-height-14px  bg-transparent border-all border-primary-color px-3 py-2" onClick={handleClear}>Clear</button>
                    <GradientButton label={"Apply filter"}
                        onPress={handleApply}
                        className="me-2 border-radius-8px e-font-14 line-height-14px e-poppins-regular padding-6px-tb " />
                </div>

            </div>
        );
    };


    const _applyFilters = (filters) => {
        setPageNum(1);
        _revenueReport(filters, searchQuery, 1, pageSize);
        setAppliedFilters(filters);
        setShowFilterPanel(false);
    };

    const _handlePageChange = (page) => {
        setPageNum(page);
        _revenueReport(appliedFilters, searchQuery, page, pageSize);
    };

    const _handleRowsPerPageChange = (newPageSize, newPage) => {
        setPageSize(newPageSize);
        setPageNum(newPage ?? 1);
        _revenueReport(appliedFilters, searchQuery, newPage ?? 1, newPageSize);
    };

    const _handleFilterPanel = (status) => {
        setShowFilterPanel(status);
    };

    const _nextPage = () => {
        if (pageNum >= totalPages) return;
        const nextPage = pageNum + 1;
        setPageNum(nextPage);
        _revenueReport(appliedFilters, searchQuery, nextPage, pageSize);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const _previousPage = () => {
        if (pageNum <= 1) return;
        const prevPage = pageNum - 1;
        setPageNum(prevPage);
        _revenueReport(appliedFilters, searchQuery, prevPage, pageSize);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };


    return (
        <Fragment>
            <NavigationHeader title="Revenue report" type={1} />

            <div className="ps-4 pe-4 padding-32px-top">

                {/* -------- TOP TITLE -------- */}
                <div className="row align-items-center mb-3 position-relative">

                    {/* LEFT SIDE: TITLE */}
                    <div className="col-5">
                        <p className="e-poppins-medium e-font-20 mb-0">
                            Monthly revenue report
                        </p>
                    </div>

                    {/* RIGHT SIDE: SEARCH + FILTER */}
                    <div className="col-7 d-flex justify-content-end align-items-center gap-3">

                        {/* SEARCH INPUT */}
                        <div className="w-372px">
                            <SearchInput
                                placeholder="Search using client name scheme name"
                                value={searchQuery}
                                valueChange={_handleSearchQuery}
                                handleSearch={_handlePress}
                            />

                        </div>


                        {/* FILTER BUTTON */}
                        <div
                            onClick={() => setShowFilterPanel(!showFilterPanel)}
                            className="d-flex align-items-center gap-1 border-radius-6px p-2 px-3 border bg-white cursor-pointer position-relative"
                        >
                            <span className="e-poppins-medium e-font-14">Filter</span>
                            <img draggable={false}
                                src={require('../../../Assets/Images/Users/filter.png')}
                                alt="Filter"
                                width={20}
                                height={20}
                            />

                            {activeFilterCount > 0 && (
                                <span className="color-white border-radius-100px e-poppins-bold e-font-12 line-height-12px e-filter-badge position-absolute bg-sea-green d-flex justify-content-center align-items-center">{activeFilterCount}</span>
                            )}

                            {/* FILTER PANEL OUTSIDE (so it takes full width) */}
                            {showFilterPanel && (
                                <>
                                    {/* DARK BACKDROP */}
                                    <div
                                        className="filter-backdrop"
                                        onClick={() => setShowFilterPanel(false)}
                                    />
                                    <div className="position-absolute end-0  top-36px w-860px filter-panel-container  mt-2"
                                        onClick={(e) => e.stopPropagation()}
                                        style={{ zIndex: 999 }}>
                                        <RevenueFilterPanel
                                            month={month} setMonth={setMonth}
                                            zone={zoneValue} setZone={setZoneValue}
                                            region={regionValue} setRegion={setRegionValue}
                                            branch={branchValue} setBranch={setBranchValue}
                                            rm={rmValue} setRm={setRmValue}
                                            ap={apValue} setAp={setApValue}
                                            admin={adminValue} setAdmin={setAdminValue}
                                            asset={assetValue} setAsset={setAssetValue}
                                            transaction={trxnValue} setTransaction={setTrxnValue}
                                            trunction={subTrxnValue} setTrunction={setSubTrxnValue}
                                            regionFilter={regionFilter}
                                            branchFilter={branchFilter}
                                            zoneFilter={zoneFilter}
                                            rmFilter={rmFilter}
                                            apFilter={apFilter}
                                            setRmFilter={setRmFilter}
                                            setApFilter={setApFilter}
                                            transactionTypeFilter={transactionTypeFilter}
                                            assetTypeFilter={assetTypeFilter}
                                            subTransactionTypeFilter={subTransactionTypeFilter}
                                            adminType={adminType}
                                            showZoneFilter={showZoneFilter}
                                            showRegionFilter={showRegionFilter}
                                            showBranchFilter={showBranchFilter}
                                            showRMFilter={showRMFilter}
                                            showAPFilter={showAPFilter}
                                            _regionFilter={_regionFilter}
                                            _branchFilter={_branchFilter}
                                            _rmFilter={_rmFilter}
                                            _apFilter={_apFilter}
                                            onApplyFilter={_applyFilters}
                                            onClear={() => {
                                                setMonth(null);
                                                setAdminValue(null);
                                                setAssetValue(null);
                                                setTrxnValue(null);
                                                setSubTrxnValue(null);
                                                setRmValue(null);
                                                setApValue(null);
                                                if (showZoneFilter && zoneFilter.length > 0) {
                                                    const defaultZone = zoneFilter.find(z => z.label === DEFAULT_ZONE_NAME) ?? zoneFilter[0];
                                                    setZoneValue(defaultZone);
                                                    setRegionValue(null);
                                                    setBranchValue(null);
                                                    setAppliedFilters({ zone: defaultZone });
                                                    if (showRegionFilter) _regionFilter(defaultZone.value);
                                                    _revenueReport({ zone: defaultZone }, searchQuery, 1, pageSize);
                                                } else {
                                                    setZoneValue(null);
                                                    setRegionValue(null);
                                                    setBranchValue(null);
                                                    setAppliedFilters({});
                                                    _revenueReport();
                                                }
                                            }}
                                        />

                                        {/* <RevenueFilter
                                            filterPanel={_handleFilterPanel}
                                            handleApply={_revenueReport}
                                        /> */}
                                    </div>
                                </>
                            )}
                        </div>

                    </div>

                </div>


                {/* -------- REVENUE CARDS -------- */}
                <div className="d-flex justify-content-between align-items-end mb-2 pb-1">

                    <div className="d-flex gap-3 align-items-center flex-wrap">
                        {revenueCards.map((item, index) => (
                            <div
                                key={index}
                                className="p-3 bg-dark-alice-blue border-radius-24px border-bright-gray border-all"
                                style={{ width: 180 }}
                            >
                                <p className="e-poppins-medium mb-0 color-charleston-green-light line-height-20px e-font-14 padding-26px-bottom">
                                    {item.label}
                                </p>

                                <p className="e-inter-medium e-font-18 line-height-22px color-jett-black mb-1">
                                    {/* ₹ {revenueCardDetails?.[item.key] ?? "0"} */}
                                    ₹ {Number(revenueCardDetails?.[item.key] ?? 0).toFixed(2)}

                                </p>
                            </div>
                        ))}
                    </div>

                    <DownloadButton
                        onPress={_reportDownload}
                        loader={downloadLoader}
                        disabled={downloadLoader}
                    />

                </div>


                {/* -------- TABLE -------- */}
                {loader ? (
                    <CustomLoader />
                ) : (
                    <div className="position-relative">
                        <DataTableContainer
                            columns={REVENUE_COLUMNS}
                            data={revenueList}
                            customStyles={TABLE_STYLE}
                            pagination={totalRows > pageSize}
                            paginationServer={true}
                            paginationTotalRows={totalRows}
                            paginationPerPage={pageSize}
                            paginationComponentOptions={paginationData}
                            onChangePage={_handlePageChange}
                            onChangeRowsPerPage={_handleRowsPerPageChange}
                        />
                        {totalRows > pageSize && (
                            <div className="d-flex justify-content-end align-items-center mt-3 position-absolute bottom-16px right-24 w-max-content">
                                <Icon
                                    icon="pagination-previous"
                                    width="24px"
                                    height="24px"
                                    className={pageNum === 1 ? 'pointer-events-none opacity-4 mx-3' : 'mx-3 cursor-pointer'}
                                    onClick={_previousPage}
                                />
                                <Icon
                                    icon="pagination-next"
                                    width="24px"
                                    height="24px"
                                    className={pageNum >= totalPages ? 'ms-1 pointer-events-none opacity-4' : 'ms-1 cursor-pointer'}
                                    onClick={_nextPage}
                                />
                            </div>
                        )}
                    </div>
                )}

            </div>




        </Fragment>
    );
};

export default RevenueReport;
